import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AutoComplete, useFetch } from "@4uhub/lib4uhub";

import { ScheduleAppointmentService } from "../../../../Schedule.service";
import { IGroupExam } from "../../../../model";


const ExamGroup = () => {
  const [examGroups, setExamGroups] = useState<IGroupExam[]>([]);

  const { sendRequest } = useFetch(ScheduleAppointmentService.getExamGroups);

  const { t } = useTranslation();

  const fetch = useCallback(async () => {
    const { success, data } = await sendRequest(null);

    if (success && data) {
      setExamGroups(data);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <AutoComplete
      options={examGroups.map((s) => ({
        id: String(s.groupingIdentifier),
        name: s.groupingName,
      }))}
      getOptionLabel={(option) => {
        return option.name;
      }}
      size="small"
      label={t("components.scheduleAssistant.newSchedule.search.examGroup")}
      name="search.examGroup"
      sx={{ mb: 2 }}
    />
  );
};

export default memo(ExamGroup);
